import React, { useState } from "react";

function PrimaryButton({
  type,
  disabled,
  children,
  onClick,
  className,
  startIcon,
  mobile = false,
}) {
  const baseClasses =
    "flex items-center font-medium text-sm border-0 shadow-md";
  const mobileClasses = mobile
    ? "px-4 py-2.5 rounded-full bg-black text-white hover:bg-gray-500"
    : "px-3 py-1.5 rounded-lg bg-blue-600 text-white hover:bg-blue-500";
  const shadowClasses =
    "shadow-[0_0_0_0.2rem_rgba(0,0,0,0.1)] hover:shadow-[0_0_0_0.2rem_rgba(0,0,0,0.2)]";
  const disabledClasses = disabled
    ? "opacity-50 cursor-not-allowed"
    : "cursor-pointer";

  const buttonClasses = `${baseClasses} ${mobileClasses} ${shadowClasses} ${disabledClasses} ${
    className || ""
  }`;

  const handleClick = (e) => {
    if (onClick) onClick(e);
  };

  return (
    <button
      type={type}
      disabled={disabled}
      className={buttonClasses}
      onClick={handleClick}
    >
      <div className="flex flex-row gap-2 items-center">
        {startIcon}
        {children}
      </div>
    </button>
  );
}

export default PrimaryButton;
